
// 全局loading
export const SET_LOADING = 'setLoading'
